import React, { useState } from "react";
import FormContainer from "../Components/Form/FormContainer";
import Input from "../Components/Form/Input";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Error from "../Components/Alerts/Error";
import {
  auth,
  createUserWithEmailAndPassword,
  firestore,
} from "../Firebase/config";
import { collection, addDoc } from "firebase/firestore";
import { useDispatch } from "react-redux";
import { login } from "../Features/userSlice";
import { setDietData, setWorkoutData } from "../Firebase/api";
import { defaultData } from "../Features/workoutSlice";
import { defaultDietList } from "../Features/DietSlice";

export default function Signup() {
  const { register, handleSubmit, watch, formState } = useForm();
  const { errors } = formState;
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [error, setError] = useState();
  const signup = async (data) => {
    createUserWithEmailAndPassword(auth, data.email, data.password)
      .then(async (userCredential) => {
        // console.log(userCredential.user);

        //*  Creating user Document
        try {
          const docRef = await addDoc(collection(firestore, "users"), {
            email: data.email,
          });
          //* storing current user data and document ID
          const id = docRef.id;
          dispatch(login({ email: data.email, docId: id }));
          const workoutId = await setWorkoutData(id)
          dispatch(defaultData(workoutId))
          const dietId = await setDietData(id)
          dispatch(defaultDietList(dietId))
        } catch (error) {
          console.log(error);
        }
        navigate("/profile");
      })
      .catch((error) => {
        setError(error.message);
      });


  };
  return (
    <>
      <FormContainer>
        {errors.email?.message && <Error message={errors.email?.message} />}
        {error && <Error message={error} />}
        <div className="w-full rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 bg-gray-800 border-gray-700">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight  md:text-2xl text-white">
              Create Account
            </h1>

            <form
              className="space-y-4 md:space-y-6"
              onSubmit={handleSubmit(signup)}
            >
              <Input
                type="email"
                label="E-mail"
                placeholder="name@company.com"
                {...register(
                  "email",
                  {
                    required: "Enter Email",
                  },
                  {
                    Pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Enter Valid Email",
                    },
                  }
                )}
              />
              <Input
                type="password"
                label="Password"
                placeholder="********"
                {...register(
                  "password",
                  { required: "For Login Enter Password" },
                  {
                    validate: (value) => {
                      return (
                        (8 < value.length && value.length < 16) ||
                        "Password Length is between 8-16"
                      );
                    },
                  }
                )}
              />
              <Input
                type="password"
                label="Confirm Password"
                placeholder="********"
                {...register("confirm password", {
                  validate: (value) => {
                    if (value !== watch("password")) return "Enter Valid Email";
                  },
                })}
              />
              <button
                type="submit"
                className="w-full text-white focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center bg-blue-600 hover:bg-bule-700 focus:ring-blue-800"
              >
                Create an account
              </button>
              <p className="text-sm font-light  text-gray-400">
                Already have an account?{" "}
                <Link
                  to="/login"
                  className="font-medium hover:underline text-blue-500"
                >
                  login here
                </Link>
              </p>
            </form>
          </div>
        </div>
      </FormContainer>
    </>
  );
}
